import React from 'react';
import {getIcon} from "../service/Icon";

// Function to get category color (same as in MapView.js)
const getCategoryColor = (categoryId) => {
    const colorMap = {
        1: '#73456F',   // Nuklearmedizin
        2: '#108F64',   // Radiojodtherapie
        3: '#E0003A',   // Chirurgie
        4: '#F7CB24',   // Rehabilitation
        5: '#315596',   // Thermoablation
        6: '#b06c27',   // Endokrinologie
        7: '#5AA5DC',   // HNO
        8: '#108F64',   // Rehabilitation (alternative)
        9: '#FF6D00',   // Thermoablation (alternative)
        12: '#9C27B0',  // Endokrinologie (alternative)
        13: '#5AA5DC'   // HNO (alternative)
    };
    return colorMap[categoryId] || '#757575';
};

// SVG Category Icon Component
const CategoryIcon = ({ categoryId, title, size = 30 }) => {
    const color = getCategoryColor(categoryId);

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '8px', verticalAlign: 'middle' }}
        >
            <circle
                cx="15"
                cy="15"
                r="14"
                fill={color}
                stroke="#fff"
                strokeWidth="2"
            />
            <path
                d="M21.4 4.9c-.2.9-.4 1.7-.8 2.5-.3.8-.7 1.6-1.2 2.3-.5.7-1.2 1.3-2 1.7-.8.4-1.7.6-2.5.5-.9 0-1.7-.2-2.6-.5-.8-.3-1.6-.6-2.4-1-.4-.2-.7-.4-1.1-.6-.2-.1-.4-.2-.6-.4 0 0-.4-.2-.5-.4-.6-.5-1.1-1.1-1.4-1.9l-.1-.2C6.1 7 6 7 6 7c-.3.2-.6.3-.9.3-.1-.1-.3-.1-.4-.3-.2-.1-.3-.2-.4-.4.1.2.2.4.3.5.1.1.3.3.5.3h.6c.1 0 .3-.1.3-.1.1.4.3.7.5 1 .3.4.5.7.9 1 .2.2.6.5.6.5.2.1.4.2.5.4.4.2.8.5 1.1.7.8.4 1.6.8 2.5 1.1.4.1.9.3 1.3.4.5.1.9.1 1.4.1.9 0 1.9-.2 2.8-.6.4-.2.8-.5 1.2-.8.3-.3.6-.7.9-1.1.3-.4.5-.8.7-1.2.2-.4.4-.8.5-1.2.3-.9.4-1.8.5-2.7M6.6 8.5v.2c0 .2.1.3.1.6 0 .2.1.5.1.7.1.4.2.6.2.9 0 .3 0 .6.1 1 0 .3 0 .7.1 1V14c0 .4 0 .7-.1 1.1 0 .1-.1.2-.1.3 0 .1-.2.3-.2.3-.1.2-.3.3-.4.4-.6.4-1.2.7-1.7.8-.5.1-1 .2-1.3.2h-.5s.2 0 .5-.1.8-.1 1.3-.3c.5-.2 1.1-.4 1.6-.8.2-.2.5-.5.5-.8.1-.3.1-.7.1-1.1v-2.1c0-.7-.1-1.3-.1-1.8 0-1.1-.1-1.7-.1-1.7-.1 0-.1.1-.1.1m11.3 5.9c-.2-1.2-.4-1.7-.9-1.7-.5.1-1.1 1.2-1.3 1.6-.1.3-.3.7-.5.8-.3.1-.6 0-1 0-.3 0-.4 0-.8-.4-.2-.2-.4-.4-.6-.8-.7-1.1-1.3-1.7-1.8-1.6-.4.1-1.1.4-1.3 2-.1.6-.1 1.2 0 1.9.3 2.2 1.3 3.4 2 3.7.1 0 .2.1.3.1.4 0 .8-.3 1.2-.5l.6-.3c.3-.2.9-.5 1.2-.3.2.1.5.5.6.6.2.2.8.8 1.5-.6s.9-3.3.8-4.5M17.4 2.5c5 1.4 8.7 6.1 8.7 11.6 0 6.6-5.4 12-12 12-5.5 0-10.1-3.7-11.6-8.7 1.2 5.8 6.3 10.1 12.4 10.1 7 0 12.6-5.6 12.6-12.6 0-6.1-4.4-11.2-10.1-12.4M19 11.4c0 .3 0 .8.1 1.3 0 .6.1 1.2.1 1.9 0 .3.1.7.1 1 .1.3.2.7.3.9.2.2.4.5.7.6.3.2.6.3.9.5l.9.3.9.3c.5.1 1 .3 1.3.4.3.1.5.1.5.1s-.7-.1-1.8-.3c-.5-.1-1.2-.3-1.8-.5-.3-.1-.7-.3-1-.5-.3-.2-.6-.4-.9-.7-.2-.3-.3-.7-.4-1.1-.1-.4-.1-.7-.1-1.1v-1.9c0-1.1.1-1.6.1-1.6 0 .1 0 .1.1.4m-2.1-7.5h-.2c-.1 0-.8-.4-1.8.3-.3.2-.8.6-.8.6l-.2.2s-.1.1 0 .1 1-.7 1.3-.8.7-.2 1-.2c.3.1.4.1.5.1h.2c.1 0 .8-.2 1.2.1.4.3.5.6.7.8.2.2.3.3.5.4 0 0-.4-.5-.5-.8-.2-.3-.4-.8-1.2-.9-.4.1-.7.1-.7.1M18.9 5.8s.1.1 0 0c-.1 0-1-.6-1.9-.6h-1.1c-.3-.1-.7-.1-1 0s-1.3.2-1.9 0c-.2 0-.1-.1 0 0s1.1 0 1.8-.2.8-.1 1.3-.1 1.2.1 1.5.2c.2.1.6.2 1.3.7m-.4.3s.1 0 0 0c-.1.1-.8.4-2.3.3s-2.4-.6-2.4-.6-.1-.1 0 0c.1 0 1.6.3 2.5.4.9 0 1.8 0 2.2-.1"
                fill="#fff"
            />
        </svg>
    );
};

class CategoryList extends React.Component {

    static defaultProps = {
        className: '',
        categories: [],
        onClick: () => {
        }
    }

    render() {

        const {filter} = this.props;
        // Sort categories alphabetically by title
        const sortedCategories = [...this.props.categories].sort((a, b) =>
            a.category_title.localeCompare(b.category_title, 'de')
        );

        return (
            <div className={'container-fluid category-grid ' + this.props.className}>
                <div className="row">
                    {sortedCategories.map(category => {
                        return (
                            <div className="col-xs-12 col-sm-6 col-md-6" key={category.category_id}>
                                <label style={{ display: 'flex',  alignItems: 'center', marginBottom: '10px', cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        value={category.category_id}
                                        onChange={this.props.onClick}
                                        checked={(filter.categories.includes(category.category_id.toString()))}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <span style={{ flex: 1, textAlign: 'left' }}>{category.category_title}</span>
                                    <CategoryIcon
                                        categoryId={parseInt(category.category_id)}
                                        title={category.category_title}
                                        size={34}
                                    />
                                </label>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

}

export default CategoryList;
